import cn from 'classnames';
import type { ReactNode } from 'react';

import { hasValue } from 'utils/hasValue';

type Props = {
  item: ReactNode;
  title?: string;
  secondaryItem?: string;
  'data-testid'?: string;
  classNames?: string;
};

export const DetailsItem = ({
  title,
  item,
  secondaryItem = '',
  'data-testid': dataTestId,
  classNames
}: Props) => {
  if (!hasValue(item)) {
    return null;
  }
  return (
    <div
      className={cn('break-words pb-6', classNames)}
      data-testid={dataTestId}
    >
      {title && <p className="text-base text-content-secondary">{title}</p>}
      <div className="text-base font-medium">
        {item}
        <h4>{secondaryItem}</h4>
      </div>
    </div>
  );
};
